var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7463 5.81648L24.8585 12.8431V26.1835H7.1418V5.81648H18.7463ZM18.7463 2.90691H7.1418C5.74977 2.90691 4.61084 4.21622 4.61084 5.81648V26.1835C4.61084 27.7838 5.74977 29.0931 7.1418 29.0931H24.8585C26.2506 29.0931 27.3895 27.7838 27.3895 26.1835V12.8431C27.3895 12.0721 27.1237 11.3301 26.6429 10.7919L20.5306 3.76523C20.0624 3.21241 19.417 2.90691 18.7463 2.90691ZM9.67276 20.3644H22.3276V23.2739H9.67276V20.3644ZM9.67276 14.5452H22.3276V17.4548H9.67276V14.5452ZM9.67276 8.72606H18.5311V11.6356H9.67276V8.72606Z",
    fill: "#EAC176"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.3861f3e3e8daa31152ed986ba9ba166e.svg";
export { ForwardRef as ReactComponent };